var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetailAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5f33db;\n        stroke: #5f33db;\n        stroke-width: 1.2px;\n        paint-order: stroke fill;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.5,21.5H46v-3.5c0-5.5-4.5-10-10-10s-10,4.5-10,10v3.5h-7.5c-2.8,0-5,2.2-5,5l-3.2,34.8c-.2,2.6,1.8,4.7,4.4,4.7h42.6c2.6,0,4.6-2.1,4.4-4.7l-3.2-34.8c0-2.8-2.2-5-5-5ZM29,18c0-3.9,3.1-7,7-7s7,3.1,7,7v3.5h-14v-3.5ZM54.2,63H17.8l-2.9-31.5c0-.8.7-1.5,1.5-1.5h39.2c.8,0,1.5.7,1.5,1.5l-2.9,31.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,34c-4.4,0-8,3.6-8,8s3.6,8,8,8,8-3.6,8-8-3.6-8-8-8ZM36,47c-2.8,0-5-2.2-5-5s2.2-5,5-5,5,2.2,5,5-2.2,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.5,40.5h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,31.5c.7,0,1.2.5,1.2,1.2v1.3h-2.4v-1.3c0-.7.5-1.2,1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,46v1.3c0,.7-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2V46h2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,40.8h1.3c.7,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2H44v-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,42c0-.7.5-1.2,1.2-1.2h1.3v2.4h-1.3c-.7,0-1.2-.5-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.5,13.5c-1.8,0-3.3.8-4.5,2-1.2-1.2-2.7-2-4.5-2,1.8,0,3.3-.8,4.5-2,1.2,1.2,2.7,2,4.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,28c-1.5,0-2.8.6-3.8,1.7-1-1.1-2.3-1.7-3.8-1.7,1.5,0,2.8-.6,3.8-1.7,1,1.1,2.3,1.7,3.8,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.5,16c-1.4,0-2.5.6-3.4,1.5-.9-.9-2-1.5-3.4-1.5,1.4,0,2.5-.6,3.4-1.5.9.9,2,1.5,3.4,1.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailAi);
export default __webpack_public_path__ + "static/media/retail_AI.80b4c1f029b8b5cd5c9116855d3eba56.svg";
export { ForwardRef as ReactComponent };